import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  width: 100%;
  max-height: 300px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`;

export const BlockText = styled.div`
  color: #1b203a;
  font-size: 14px;
  font-weight: 500;
  margin-left: 9px;
`;

export const StatusIcon = styled.div`
  height: 20px;
  overflow: hidden;
`;
